// extracted by mini-css-extract-plugin
module.exports = {"container":"UsageStats_container__1FBGu","stat":"UsageStats_stat__2j0xY","label":"UsageStats_label__2eOLL","value":"UsageStats_value__1GshC"};